import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { MasterContactService } from "./master-contact.service";
import { loadMasterContactAddresses, loadMasterContactAddressesFailure, loadMasterContactAddressesSuccess } from "./master-contact.actions";

@Injectable()
export class MasterContactEffects {
    constructor(private actions$: Actions, private masterContactService: MasterContactService) { }

    // loadMasterContactAddresses$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(loadMasterContactAddresses),
    //         switchMap(() =>
    //             this.masterContactService.getMasterContactAddresses().pipe(
    //                 map((addresses) => loadMasterContactAddressesSuccess({ addresses })),
    //                 catchError((error) => of(loadMasterContactAddressesFailure({ error: error.message })))
    //             )
    //         )
    //     )
    // );
}